import React from 'react';
import PropTypes from 'prop-types';
import bowser from 'yola-bowser';
import classNames from 'classnames';
import connectWhen from './helpers/connect-when';
import TreeViewActions from './tree-view-actions';
import Render from '../render';
import Icon from '../icon';
import { ListItem } from './constants/types';

class TreeViewItemPreview extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isActiveTrigger: false,
      isItemFocused: false,
    };

    this.activateDragTrigger = this.activateDragTrigger.bind(this);
    this.deactivateDragTrigger = this.deactivateDragTrigger.bind(this);
    this.onItemFocus = this.onItemFocus.bind(this);
    this.onItemBlur = this.onItemBlur.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mouseup', this.deactivateDragTrigger, false);
  }

  componentWillUnmount() {
    document.removeEventListener('mouseup', this.deactivateDragTrigger, false);
  }

  onItemFocus() {
    this.setState({ isItemFocused: true });
  }

  onItemBlur() {
    this.setState({ isItemFocused: false });
  }

  activateDragTrigger() {
    this.setState({
      isActiveTrigger: true,
    });
  }

  deactivateDragTrigger() {
    const { isActiveTrigger } = this.state;

    if (isActiveTrigger) {
      this.setState({
        isActiveTrigger: false,
      });
    }
  }

  render() {
    const { item, connectDragSource, isDragPreview, isDragging, isDnDEnabled } = this.props;
    const { isActiveTrigger, isItemFocused } = this.state;
    const isMobile = bowser.mobile || bowser.tablet;
    const className = classNames('ws-tree-view-item-preview', {
      'ws-tree-view-item-preview--is-dragging': !isDragPreview && isDragging,
      'ws-tree-view-item-preview--is-mobile': isMobile,
      'ws-tree-view-item-preview--multiple-items-preview ': isDragPreview && item.items.length > 0,
    });
    const dragTriggerClass = classNames('ws-tree-view-item-preview__icon-wrapper', {
      'ws-tree-view-item-preview__icon-wrapper--grabbing-cursor': isActiveTrigger,
    });

    const { customDragTrigger } = item;
    const defaultDragTrigger = <Icon glyph="drag" strokeWidth="1.3" />;
    const dragTrigger =
      customDragTrigger && (isItemFocused || !isDnDEnabled)
        ? defaultDragTrigger
        : customDragTrigger;
    return (
      <div className={className} onMouseEnter={this.onItemFocus} onMouseLeave={this.onItemBlur}>
        <div className="ws-tree-view-item-preview__text-wrapper">
          {connectWhen(
            isDnDEnabled,
            connectDragSource
          )(
            <span className={dragTriggerClass} onMouseDown={this.activateDragTrigger}>
              {dragTrigger || defaultDragTrigger}
            </span>
          )}
          {item.title}
        </div>

        <Render if={!isDragPreview && Boolean(item.actions && item.actions.length)}>
          <TreeViewActions item={item} />
        </Render>
      </div>
    );
  }
}

TreeViewItemPreview.propTypes = {
  isDragPreview: PropTypes.bool,
  item: ListItem.isRequired,
  connectDragSource: PropTypes.func,
  isDragging: PropTypes.bool,
  isDnDEnabled: PropTypes.bool,
};

TreeViewItemPreview.defaultProps = {
  isDragPreview: false,
  isDragging: false,
  isDnDEnabled: false,
  connectDragSource: (node) => node,
};

export default TreeViewItemPreview;
